import { Button, Card, Image } from "antd";
import { PopUp } from "../../../../atoms/PopUp";
import ChangePasswordPopUp from "../ChangePasswordPopUp";
import { useState } from "react";
import { UserType } from "../../ducks/types";

type PropsType = {
  data: UserType | null;
};

export default function ChangePassword(props: PropsType) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data } = props;

  const changePasswordPopup = {
    visibility: isModalOpen,
    content: (
      <ChangePasswordPopUp
        onClose={() => setIsModalOpen(false)}
        id={data?.id || ""}
      />
    ),
    width: 640,
    onCancel: () => setIsModalOpen(false),
  };
  return (
    <Card className="pswCard">
      <Button className="pswButton" onClick={() => setIsModalOpen(true)}>
        <div className="pswTop">
          <div className="pswIcon">
            <Image
              src="/images/myProfile/lock_icon.svg"
              alt="lock"
              preview={false}
            />
          </div>
        </div>
        <h3>Change password</h3>
        <p>Update your password when you need it.</p>
      </Button>

      <PopUp {...changePasswordPopup} />
    </Card>
  );
}
